import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import { ProductOrderService } from "../../../service/ProductOrderService";
import ProductOrderResponse from "../../../model/productOrder/ProductOrderResponse";

class ClientOrderReceiptsStore {

    public clientId: string;
    public from: number;
    public to: number;
    public orders: ProductOrderResponse[];
    public selectedOrders: ProductOrderResponse[]
    public isModalOpen: boolean;
    public showReceipt: boolean;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, from: number, to: number, clientId: string) {
        this.from = from;
        this.to = to;
        this.clientId = clientId;
        this.isModalOpen = false;
        this.orders = [];
        this.selectedOrders = [];
        this.loading = false;
        this.showReceipt = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }

    @action
    public async loadOrders() {
        this.loading = true;
        const response = await ProductOrderService.get(this.from, this.to, this.clientId);
        if (response.success && response.data) {
            this.orders = response.data;
            this.loading = false;
        }
        this.commonStore.processErrors(response);
    }

    toggleOrderSelection(order: ProductOrderResponse) {
        this.showReceipt = false;
        const exists = this.selectedOrders.some(o => o.id === order.id);
        if (exists) {
            this.selectedOrders = this.selectedOrders.filter(o => o.id !== order.id);
        } else {
            this.selectedOrders.push(order);
        }
    }

    isOrderSelected(order: ProductOrderResponse) {
        return this.selectedOrders.some(o => o.id === order.id);
    }

    @action
    public async openModal() {
        this.loading = true;
        this.isModalOpen = true;
        this.loading = false;
    }

    @action
    public closeModal() {
        this.selectedOrders = [];
        this.showReceipt = false;
        this.orders = [];
        this.isModalOpen = false;
        this.loading = false;
    }

}

export default ClientOrderReceiptsStore;